import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const listGroupDefaultVariants = {
  "size": "md",
  "palette": "default"
}
const listGroupCompoundVariants = []

const listGroupSlotNames = [
  [
    "root",
    "ListGroup__root"
  ],
  [
    "item",
    "ListGroup__item"
  ],
  [
    "header",
    "ListGroup__header"
  ],
  [
    "section",
    "ListGroup__section"
  ],
  [
    "addonStart",
    "ListGroup__addonStart"
  ],
  [
    "addonEnd",
    "ListGroup__addonEnd"
  ],
  [
    "icon",
    "ListGroup__icon"
  ],
  [
    "divider",
    "ListGroup__divider"
  ],
  [
    "label",
    "ListGroup__label"
  ],
  [
    "description",
    "ListGroup__description"
  ],
  [
    "content",
    "ListGroup__content"
  ]
]
const listGroupSlotFns = /* @__PURE__ */ listGroupSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, listGroupDefaultVariants, getSlotCompoundVariant(listGroupCompoundVariants, slotName))])

const listGroupFn = memo((props = {}) => {
  return Object.fromEntries(listGroupSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const listGroupVariantKeys = [
  "size",
  "palette"
]
const getVariantProps = (variants) => ({ ...listGroupDefaultVariants, ...compact(variants) })

export const listGroup = /* @__PURE__ */ Object.assign(listGroupFn, {
  __recipe__: false,
  __name__: 'listGroup',
  raw: (props) => props,
  variantKeys: listGroupVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ],
  "palette": [
    "default",
    "danger",
    "warning"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, listGroupVariantKeys)
  },
  getVariantProps
})